import React from "react";
import { BRAND_TXT } from "../lib/brand";

export const PieMarca = () => (
  <footer className="px-4 sm:px-8 pt-4 pb-44 lg:pb-4 mt-6 border-t border-slate-200 flex items-center gap-3 flex-wrap text-xs text-slate-500" data-testid="pie-marca">
    <img src="/img/farmanaliza-logo.png" alt="Farmanaliza" className="h-6 w-auto" />
    <span data-testid="pie-marca-texto">{BRAND_TXT}</span>
  </footer>
);
